export default "__VITE_ASSET__N0pjNSGe__"